export default () => ({
    $body: null,
    $window: null,
    window_width: null,
    window_height: null,
});
